import React from "react";
import "./ErrorPage.css"; // Import the CSS file for styling

const ErrorPage = () => {
  return (
    <div className="error-page">
      <div className="error-content">
      <img src="/images/webdoc-white.webp" alt="Logo" className="error-logo" />
        <h3>Something Went Wrong</h3>
        <p>Invalid credentials or an error occurred. Please try again later.</p>
        <button
          className="go-home-btn"
        >
          Try Again
        </button>
      </div>
    </div>
  );
};

export default ErrorPage;
